import React from 'react';
import PropTypes from 'prop-types';
import SuggestionItem from './SuggestionItem';
import CategoryHeader from './CategoryHeader';
import { locationShape } from '../../shape/locationShape';
import { RECENT_SEARCHES_KEY } from '../../constants/categoryConstants';

const CategoryList = ({
  headerCopy,
  iconNode,
  iconProps,
  suggestions,
  categoryIndex,
  headerText,
  categoryOffset,
  indexIncrement,
  categoryKey,
}) => (
  <ul
    id={`category-${categoryIndex}`}
    aria-labelledby={`category-${categoryIndex}-header`}
    className="pad-0-l flex flex-column"
    style={{ listStyleType: 'none' }}
    role="group"
  >
    <CategoryHeader
      categoryIndex={categoryIndex}
      IconNode={iconNode}
      iconProps={iconProps}
      headerCopy={headerCopy}
      headerText={headerText}
      hasClearHistory={categoryKey === RECENT_SEARCHES_KEY}
    />
    {
        suggestions.map(({
          id,
          name,
          label,
          toLabel,
          airportCode,
          toAirportCode,
          parentId,
          type,
          geoLocation,
          searchIdType,
          dates,
        }, index) => (
          <SuggestionItem
            key={id}
            id={id}
            name={name}
            label={label}
            toLabel={toLabel}
            airportCode={airportCode}
            toAirportCode={toAirportCode}
            dates={dates}
            parentId={parentId}
            type={type.toUpperCase()}
            geoLocation={geoLocation}
            searchIdType={searchIdType}
            suggestionIndex={index + categoryOffset + indexIncrement}
          />
        ))
      }
  </ul>
);

CategoryList.propTypes = {
  headerCopy: PropTypes.string,
  headerText: PropTypes.string,
  iconNode: PropTypes.func,
  iconProps: PropTypes.shape({
    className: PropTypes.string,
    filled: PropTypes.bool,
    size: PropTypes.string,
  }),
  suggestions: PropTypes.arrayOf(PropTypes.shape(locationShape)).isRequired,
  categoryKey: PropTypes.string.isRequired,
  categoryIndex: PropTypes.number.isRequired,
  categoryOffset: PropTypes.number.isRequired,
  indexIncrement: PropTypes.number.isRequired,
};

CategoryList.defaultProps = {
  iconNode: null,
  iconProps: {},
  headerText: null,
  headerCopy: null,
};

export default CategoryList;
